// extracted by mini-css-extract-plugin
export default {"borrowTable":"NotConnectedTable-module__borrowTable--rHt8Q","searchSelect":"NotConnectedTable-module__searchSelect--MEvHY"};